import { render } from "./MusteriMain.vue?vue&type=template&id=c63ae094&scoped=true"
import script from "./MusteriMain.vue?vue&type=script&lang=js"
export * from "./MusteriMain.vue?vue&type=script&lang=js"

import "./MusteriMain.vue?vue&type=style&index=0&id=c63ae094&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63ae094"]])

export default __exports__